import { useEffect, useState, useMemo } from "react"
import { Box, Grid, TextField, Typography, Paper } from "@mui/material";
import { formatNumber, formatoCalculo } from "../ApiServices";

export default function ResumenEdicion(props) {

    const totales = useMemo(() => {
        // 1. LIMPIEZA PARA CÁLCULO: De "1.000,50" a 1000.50
        const toNum = (val) => {
            if (!val) return 0;
            if (typeof val === 'number') return val;

            const limpio = val.toString()
                .replace(/\./g, "")  // Quitamos puntos de miles
                .replace(",", "."); // Cambiamos coma por punto decimal

            const num = parseFloat(limpio);
            return isNaN(num) ? 0 : num;
        };

        // --- CÁLCULOS (Siempre con números puros) ---
        const totalPapel = toNum(props.propiedades.totalMuestro);

        const itemsNetos = props.propiedades.datosCuerpo.filter(item => !item.id_impuesto);
        const itemsImpuestos = props.propiedades.datosImpuestos.filter(item => item.id_impuesto);

        const netoGravado = itemsNetos.reduce((acc, item) => acc + toNum(item.subtotal), 0);
        props.propiedades.setnetoGravado(netoGravado);
        const ivaTotal = itemsNetos.reduce((acc, item) => acc + toNum(item.monto_iva), 0);
        const otrosTributos = itemsImpuestos.reduce((acc, item) => acc + toNum(item.importe), 0);
        props.propiedades.setotrosTributos(otrosTributos)
        const sumaCargada = netoGravado + ivaTotal + otrosTributos;
        const diferencia = totalPapel - sumaCargada;
        props.propiedades.setsaldonoaplic(diferencia)

        // --- RETORNO FORMATEADO (Usando tu función formatNumber) ---
        // Usamos toFixed(2) primero para asegurar los decimales y luego tu función
        const prepararParaVista = (n) => {
            const conComa = n.toFixed(2).replace(".", ",");
            return formatNumber(conComa); // <--- Aquí aplicamos tu función
        };

        if (diferencia < 0) {
            props.propiedades.setSaldoNegativo(true)
        } else {
            props.propiedades.setSaldoNegativo(false)
        }

        return {
            neto: prepararParaVista(netoGravado),
            iva: prepararParaVista(ivaTotal),
            otros: prepararParaVista(otrosTributos),
            saldo: prepararParaVista(Math.abs(diferencia) < 0.01 ? 0 : diferencia)
        };

    }, [props.propiedades.datosCuerpo, props.propiedades.totalMuestro,props.propiedades.datosImportes]);


    /*--------------------------------STYLING ---------------------------------- */
    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#1f618d",
            },
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "#1f618d",
        },
    }

    return (
        <div>
            <Paper
                elevation={3}
                sx={{
                    background: "linear-gradient(to right, #f8f9fa, #e8f0fe)",
                    mt: 1,
                    p: 1,
                    borderRadius: 4,
                    borderLeft: "6px solid #1f618d",
                }}
            >
                <Grid container mb={1} direction={{ xs: "row", sm: "row" }} spacing={1}>
                    <Grid item xs={12} px={1} borderBottom={1} borderColor="#bbb" mb={1} pb={1}>
                        <Box
                            width="100%"
                            role="presentation"
                            sx={{
                                backgroundColor: "#1f618d",
                                color: "white",
                                borderRadius: 2,
                                boxShadow: 2,
                            }}
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Typography variant="subtitle1" display="block" textAlign="center" fontWeight="bold">
                                IMPORTES
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            sx={style}
                            focused
                            size="small"
                            label="Importe total"
                            fullWidth
                            // Refleja directamente lo que cargó el usuario arriba
                            value={props.propiedades.totalMuestro || "0,00"}
                            inputProps={{ readOnly: true }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            type="text"
                            sx={style}
                            focused
                            size="small"
                            label="Otros"
                            fullWidth
                            value={totales.otros}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            sx={style}
                            focused
                            size="small"
                            label="Importe Neto Gravado"
                            fullWidth
                            value={totales.neto}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            sx={style}
                            focused
                            size="small"
                            label="Saldo No Aplicado"
                            fullWidth
                            value={totales.saldo}
                            // Color dinámico: si el saldo no es "0,00", se pone rojo
                            error={totales.saldo !== "0,00"}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            sx={style}
                            focused
                            size="small"
                            label="IVA Total"
                            value={totales.iva}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </div>
    )
}

// const netoGravado = (datosCuerpo, setnetoGravado) => {
//         const netoGravado1 = props.propiedades.datosCuerpo.reduce((acc, lista) => {
//             const subtotalStr = String(lista?.subtotal)
//             const subtotalform = subtotalStr.replace(/\./g, "")?.replace(/,/g, ".")
//             const gravado = parseFloat(subtotalform) || 0
//             return isNaN(gravado) ? acc : acc + gravado
//         }, 0)
//         const formateado = formatNumber(String(netoGravado1).replace(".", ","))
//         // console.log("formateado", formateado);

//         // setnetoGravado(netoGravado1)
//         setnetoGravado(formateado)
//     }

//     const calcularExtras = (datosImpuestos, setotrosTributos) => {
//         const calcular = datosImpuestos.reduce((acc, lista) => {
//             const ot = parseFloat(lista?.importe?.replace(/\./g, "")?.replace(/,/g, ".")) || 0
//             // console.log("ot", ot);

//             return isNaN(ot) ? acc : acc + ot
//         }, 0)
//         setotrosTributos(formatNumber(String(calcular)?.replace(".", ",")))
//     };

//     const calcularAcumuladoDiferencias = () => {
//         const acumuladoDiferencias = {}

//         const roundUpToTwoDecimals = (num) => {
//             return Math.ceil(num * 100) / 100
//         }

//         props.propiedades.datosCuerpo.forEach((linea) => {
//             const idPorcentajeIva = linea?.id_porcentajeiva
//             const subtotalIva = parseFloat(String(linea?.subtotal_iva)?.replace(/\./g, "")?.replace(/,/g, "."))
//             const subtotal = parseFloat(String(linea?.subtotal)?.replace(/\./g, "")?.replace(/,/g, ".")) || 0
//             const diferencia = parseFloat((subtotalIva - subtotal).toFixed(2))
//             acumuladoDiferencias[idPorcentajeIva] = (acumuladoDiferencias[idPorcentajeIva] || 0) + diferencia;
//         })

//         const total = Object.values(acumuladoDiferencias).reduce((acc, valor) => {
//             const numero = parseFloat(valor.toFixed(2))
//             return acc + numero
//         }, 0)


//         props.propiedades.setIvaTotal(formatNumber(total.toFixed(2).replace(".", ",")))

//         props.propiedades.setDiferenciasPorIva(acumuladoDiferencias)

//         const netoGravadoOk = props.propiedades.neto ? formatoCalculo(props.propiedades.neto) : 0;
//         const otrosTributosOk = props.propiedades.otrostributos ? formatoCalculo(props.propiedades.otrostributos) : 0;

//         //No los podria armar cuando voy a armar el cuerpo de la solicitud ??
//         const nuevosDatosPie = []

//         props.propiedades.datosCuerpo.forEach((linea) => {
//             const idPorcentajeIva = linea.id_porcentajeiva
//             const existingIndex = nuevosDatosPie.findIndex((item) => item.id_porcentajeiva === idPorcentajeIva)
//             // console.log(existingIndex);

//             if (existingIndex !== -1) {
//                 // console.log(acumuladoDiferencias[idPorcentajeIva]);

//                 nuevosDatosPie[existingIndex] = {
//                     ...nuevosDatosPie[existingIndex],
//                     importe: roundUpToTwoDecimals(acumuladoDiferencias[idPorcentajeIva]),
//                     // importe_neto_gr: roundUpToTwoDecimals(neto),
//                     // otros_tributos: roundUpToTwoDecimals(otrostributos),
//                     importe_neto_gr: roundUpToTwoDecimals(netoGravadoOk),
//                     otros_tributos: roundUpToTwoDecimals(otrosTributosOk),
//                 }
//             } else {
//                 nuevosDatosPie.push({
//                     id_porcentajeiva: idPorcentajeIva,
//                     importe_neto_gr: roundUpToTwoDecimals(netoGravadoOk),
//                     otros_tributos: roundUpToTwoDecimals(otrosTributosOk),
//                     uuid_comprobante: linea.uuid_comprobante,
//                     usuario: linea.usuario,
//                     importe: roundUpToTwoDecimals(acumuladoDiferencias[idPorcentajeIva]),
//                 })
//             }
//         })
//         // console.log(nuevosDatosPie);

//         props.propiedades.setdatosPie(nuevosDatosPie)
//     }

//     const setearSaldo = () => {
//         let sumatoria = 0
//         props.propiedades.datosCuerpo &&
//             props.propiedades.datosCuerpo.forEach((item) => {
//                 if (parseFloat(item.subtotal_iva)) {
//                     const subt = parseFloat(item.subtotal_iva.replace(/\./g, "")?.replace(/,/g, "."))
//                     sumatoria += subt
//                 }
//             })

//         const otrosTribOk = parseFloat(props.propiedades.otrostributos?.replace(/\./g, "")?.replace(/,/g, "."))
//         let saldoNoAplic = (parseFloat(props.propiedades.total) - (sumatoria + otrosTribOk)) || 0
//         saldoNoAplic = Math.ceil(saldoNoAplic * 100) / 100
//         props.propiedades.setsaldonoaplic(saldoNoAplic < 0 ? `-${formatNumber(String(props.propiedades.saldoNoAplic)?.replace(".", ","))}` : formatNumber(String(saldoNoAplic)?.replace(".", ","))) //tengo que concatenar el 0 porque cuando formateo el nro para mostrarlo en ars, me quita el negativo y no tengo ganas de arreglarlo ahora :).
//         if (props.propiedades.saldoNoAplic < 0) {
//             props.propiedades.setSaldoNegativo(true)
//         } else {
//             props.propiedades.setSaldoNegativo(false)
//         }
//     }
/* ----------------------- EFFECTS -----------------------*/
// useEffect(() => {
//     netoGravado(props.propiedades.datosCuerpo, props.propiedades.setnetoGravado)
// }, [props.propiedades.datosCuerpo])

// useEffect(() => {
//     calcularExtras(props.propiedades.datosImpuestos, props.propiedades.setotrosTributos)
// }, [props.propiedades.datosImpuestos])

// useEffect(() => {
//     calcularAcumuladoDiferencias()
// }, [props.propiedades.datosCuerpo, props.propiedades.tiposIvaSeleccionados])

// useEffect(() => {
//     setearSaldo()
// }, [props.propiedades.total, props.propiedades.datosCuerpo, props.propiedades.otrostributos])
